export default __webpack_public_path__ + "static/media/money.9e75b92e.svg";